import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae00205"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid header__wrap" }
const _hoisted_2 = { class: "row justify-content-between align-items-center header" }
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = { class: "col-4 row justify-content-end" }

import { onMounted, ref, onUnmounted, watch } from "vue";
import Logo from "@/icons/common/logo.vue";
import SelectList from "@/components/select-list/index.vue";
import WalletSelect from "@/components/wallet-select/index.vue";
import { selectNetwork, selectNetworkItems } from "@/types/mock";
import { SelectItem, NetworkSelectItem } from "@/types/select-list";
import {
  selectedNetwork,
  apiPromise,
  accounts,
  clearNativeBalances,
} from "@/stores";
import { useGetNativePrice } from "@/libs/prices";
import { useGetNativeBalances } from "@/libs/balances";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isScroll = ref<boolean>(false);
const network = ref<SelectItem>(selectNetwork);

onMounted(() => {
  window.addEventListener("scroll", onScroll);
});
onUnmounted(() => {
  window.removeEventListener("scroll", onScroll);
});

watch([apiPromise, accounts], () => {
  clearNativeBalances;
  useGetNativeBalances();
  useGetNativePrice();
});

const onScroll = () => {
  if (window.scrollY > 22) {
    if (isScroll.value == false) isScroll.value = true;
  } else {
    if (isScroll.value == true) isScroll.value = false;
  }
};

const selectNetworkAction = async (item: NetworkSelectItem) => {
  const api = await apiPromise.value;
  await api.disconnect();
  network.value = item;
  selectedNetwork.value = item.id;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Logo)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["header__menu", { scroll: isScroll.value }])
        }, [
          _createVNode(SelectList, {
            select: network.value,
            items: _unref(selectNetworkItems),
            "is-list-image": true,
            "onUpdate:select": selectNetworkAction
          }, null, 8, ["select", "items"]),
          _createVNode(WalletSelect)
        ], 2)
      ])
    ])
  ]))
}
}

})